// extracted by mini-css-extract-plugin
module.exports = {"info-message":"issue-landing-page-m__info-message__EoSBD","editions-wrapper":"issue-landing-page-m__editions-wrapper__2_fWR"};